import { createFileRoute } from "@tanstack/react-router";
import { validateUsersSearch } from "../features/admin/use-accounts-view";
import { UsersPage } from "../features/admin/users-page";

export const Route = createFileRoute("/_app/admin/users")({
  validateSearch: validateUsersSearch,
  component: UsersPage,
});
